import Button from "./Button";
import logo from "../assets/logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import Searchbar from "./Searchbar";

function Navbar({ setSelectedCity }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="relative bg-white">
      {/* Navbar Container */}
      <div
        className={`container mx-auto flex justify-between items-center px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 ${
          location.pathname === "/" ? "py-[19px] lg:py-[21px]" : "py-4"
        }`}
      >
        {/* Logo */}
        <button onClick={() => navigate("/")} className="focus:outline-none">
          <img src={logo} alt="logo" className="w-20 sm:w-24 md:w-28 h-12" />
        </button>

        {/* Hamburger Menu */}
        <div className="md:hidden">
          <button
            onClick={toggleMobileMenu}
            className="focus:outline-none"
            aria-label="Toggle mobile menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 md:h-8 md:w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Desktop Content */}
        <div className="hidden md:flex items-center space-x-6">
          {location.pathname !== "/" && (
            <Searchbar setSelectedCity={setSelectedCity} />
          )}
          <Button
            btnContent={" CRM "}
            onclickHandler={() =>
              window.open("https://arka.se/development/crm-2.2.0/", "_blank")
            }
            className="text-sm md:text-base lg:text-md px-4 md:px-6 py-2 md:py-3"
          />

          <Button
            btnContent={"+Business"}
            onclickHandler={() => navigate("/add_company")}
            className="text-sm md:text-base lg:text-lg px-4 md:px-6 py-2 md:py-3"
          />
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white shadow-lg z-50">
          <div className="container mx-auto px-4 py-4 space-y-4">
            {location.pathname !== "/" && (
              <Searchbar setSelectedCity={setSelectedCity} />
            )}
            <div className="flex justify-center items-center">
              <Button
                btnContent={"+ Add business"}
                onclickHandler={() => {
                  navigate("/add_company");
                  setIsMobileMenuOpen(false);
                }}
                className="text-sm px-4 py-2 w-full text-center"
              />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
